export default "__VITE_ASSET__r8A0SlYVjfziQBbwLXlDeQ__"